const nav = {
  "nav.language": "Język",
  "nav.dashboard": "Panel",
  "nav.myProfile": "Mój profil",
  "profile.editProfile": "Edytuj profil",
  "profile.designedBy": "Projektant",
  "site.manageProfile.requiredNote": "Pola oznaczone * są wymagane",
  "manageProfile.section.basic": "Podstawowe informacje",
  "manageProfile.section.photo": "Zdjęcie profilowe",
  "manageProfile.section.social": "Media społecznościowe",
  "manageProfile.social.toggle": "Dodaj linki do mediów społecznościowych",
  "manageProfile.social.optional": "opcjonalne",
  "manageProfile.account.displayName.label": "Podaj imię i nazwisko lub swój pseudonim",
  "manageProfile.account.displayName.placeholder": "Twój pseudonim",
  "manageProfile.account.email.label": "Adres e-mail",
  "manageProfile.account.email.placeholder": "you@example.com",
  "manageProfile.account.bio.label": "Napisz kilka zdań o sobie",
  "manageProfile.account.bio.placeholder": "Opisz swój styl i projekty...",
  "manageProfile.account.country.label": "Kraj",
  "manageProfile.account.becomeCreator.label": "Zostań twórcą",
  "manageProfile.account.handle.label": "Profil handle",
  "manageProfile.account.handle.placeholder": "Unikalny identyfikator (np. moj-profil)",
  "manageProfile.social.website.label": "Strona internetowa",
  "manageProfile.social.website.placeholder": "https://twoja-strona.pl",
  "manageProfile.social.instagram.label": "Profil na Instagramie",
  "manageProfile.social.instagram.placeholder": "@twójprofil",
  "manageProfile.social.facebook.label": "Profil na Facebooku",
  "manageProfile.social.facebook.placeholder": "facebook.com/twójprofil",
  "manageProfile.social.youtube.label": "Konto na YouTube",
  "manageProfile.social.youtube.placeholder": "youtube.com/@twójkanał",
  "manageProfile.saveChanges": "Zapisz zmiany",
  "profile.page.title": "Mój profil",
  "profile.page.subtitle": "Informacje o Tobie pozwolą odwiedzającym lepiej poznać Twój styl!",
  "profile.nav.myPatterns": "Moje wykroje",
  "profile.nav.addPattern": "Dodaj nowy wykrój",
  "profile.nav.creatorPortal": "Portal twórcy",
  "profile.nav.purchaseHistory": "Historia zakupów",
  "profile.country.poland": "Polska",
  "profile.country.germany": "Niemcy",
  "profile.country.france": "Francja",
  "profile.country.unitedKingdom": "Wielka Brytania",
  "profile.country.usa": "USA",
  "profile.country.other": "Inne",
  "profile.patterns.lowestPriceNote": "Najniższa cena w ciągu ostatnich 30 dni przed obniżką: {price}",
  "nav.profiles": "Profile",
  "nav.descriptionpatternpage": "Opis",
  "nav.otherpatternpage": "Inne produkty sprzedawcy",
  "nav.similarpatternpage": "Podobne produkty, które mogą Cię zainteresować",
  "nav.aboutdesigner": "O projektancie",
  "nav.comments": "Komentarze",
  "nav.opinions": "Opinie",
  "nav.commentsrating": "Ocena",
  "nav.woman": "Kobieta",
  "nav.man": "Mężczyzna",
  "nav.girl": "Dziewczynka",
  "nav.boy": "Chłopiec",
  "nav.newin": "Nowe",
  "nav.sale": "Wyprzedaż",
  "nav.newseason": "Nowy Sezon",
  "nav.newcollection": "Nowa Kolekcja",
  "nav.register": "Zarejestuj się",
  "register.page.title": "Zarejestruj się",
  "register.page.subtitle": "Dołącz do społeczności Sew Light",
  "register.conditions.part1": "Rejestrując się, potwierdzasz, że zapoznałeś się z ",
  "register.conditions.termsLink": "regulaminem",
  "register.conditions.part2": " i akceptujesz ",
  "register.conditions.serviceTermsLink": "warunki korzystania z serwisu",
  "register.conditions.part3": " oraz ",
  "register.conditions.privacyPolicyLink": "polityką prywatności",
  "register.conditions.part4": ".",
  "register.errors.passwordMismatch": "Hasła nie pasują",
  "register.form.username.placeholder": "Nazwa użytkownika",
  "register.form.email.placeholder": "E-mail",
  "register.form.password.placeholder": "Hasło",
  "register.form.password2.placeholder": "Powtórz hasło",
  "register.form.newsletterConsent": "Wyrażam zgodę na otrzymywanie informacji handlowych drogą elektroniczną...",
  "register.form.admin.label": "Admin",
  "register.form.suspend.label": "Zawieś",
  "register.form.suspendReason.placeholder": "Powód zawieszenia",
  "register.form.ban.label": "Zablokuj",
  "register.form.banReason.placeholder": "Powód blokady",
  "register.button.edit": "Edytuj",
  "register.button.submit": "Zarejestruj się",
  "nav.thumpnailsDesignerTitle": "Najwyżej oceniani projektanci w kategori ",
  "nav.sorting": "Sortowanie",
  "nav.latestSort": "Najnowsze",
  "home.bestsellers": "Bestsellery",
  "home.newArrivals": "Nowości",
  "home.shopByStyle.title": "Kupuj według stylu",
  "home.shopByStyle.female": "Kobieta",
  "home.shopByStyle.male": "Mężczyzna",
  "home.shopByStyle.girl": "Dziewczynka",
  "home.designers.benefit.1.title": "Zarabiasz ile chcesz",
  "home.designers.benefit.1.subtitle": "Sama ustalaj ile wykrojów chcesz sprzedać oraz za jaką cene",
  "home.designers.benefit.2.title": "Możesz na nas liczyć",
  "home.designers.benefit.2.subtitle": "Pomożemy Ci zacząć zarabiać na własnych wykrojach. Jesteśmy tu żeby Ci pomóc",
  "home.designers.benefit.3.title": "Tworzysz społeczność",
  "home.designers.benefit.3.subtitle": "Sewlight to jedyna platforma łącząca większych i mniejszych projektantów. Cieszymy się szyciem razem",
  "home.designers.benefit.4.title": "Zgarniasz rabaty",
  "home.designers.benefit.4.subtitle": "Dla wszystkich członków Swelight są zniżki za zakup wykrojów innych designerów",
  "home.designers.benefit.5.title": "Masz spokojną głowe",
  "home.designers.benefit.5.subtitle": "Nie musisz tworzyć własnej platforni ani martwić sie formalnościami. My się tym zajmiemy",
  "home.designers.steps.register": "Zarejestruj się",
  "home.designers.steps.register.sub": "Stwórz swoje konto i zostań naszym członkiem",
  "home.designers.steps.createProfile": "Stwórz swój profil",
  "home.designers.steps.createProfile.sub": "Dodaj zdjęcia ubrań, opis produktu.",
  "home.designers.steps.addPatterns": "Dodaj swoje wykroje",
  "home.designers.steps.addPatterns.sub": "Wgraj wykrój w fromacie pdf",
  "home.designers.steps.setPrice": "Ustal cene wykroju",
  "home.designers.steps.setPrice.sub": "Sama ustalaj ile wykrojów chcesz sprzedać oraz za jaką cene",
  "home.designers.steps.startEarning": "Zacznij zarabiać",
  "home.designers.steps.startEarning.sub": "Sama ustalaj ile wykrojów chcesz sprzedać oraz za jaką cene",
  "legal.privacy.title": "POLITYKA PRYWATNOŚCI, RODO I OCHRONA DANYCH OSOBOWYCH PLATFORMY SPRZEDAZOWEJ {platform}",
  "legal.creator.title": "REGULAMIN WSPOLPRACY DLA TWORCOW PLATFORMY SPRZEDAZOWEJ {platform}",
  "legal.newsletter.title": "REGULAMIN NEWSLETTERA PLATFORMY {platform}",
  "legal.omnibus.title": "Jak działa Omnibus w tej aplikacji?",
  "legal.omnibus.backLink": "Wróć do edycji wykroju",
  "legal.platform.title": "Warunki korzystania z serwisu",
  "legal.platform.subtitle": "Zanim zarejestrujesz się w Sew light, zapoznaj się z warunkami korzystania z serwisu.",
  "legal.platform.side.regulamin": "REGULAMIN PLATFORMY SPRZEDAZOWEJ",
  "legal.platform.side.privacy": "POLITYKA PRYWATNOSCI, RODO I OCHRONA DANYCH OSOBOWYCH",
  "legal.platform.side.designers": "REGULAMIN WSPOLPRACY DLA TWORCOW",
  "legal.platform.side.newsletter": "REGULAMIN NEWSLETTERA",
  "nav.priceSort": "Cena",
  "nav.ratedSort": "Polecane",
  "patterns.filters.title": "Filtry",
  "patterns.filters.clearAll": "Wyczyść",
  "patterns.filters.clearFilters": "Wyczyść filtry",
  "patterns.filters.found": "Wykroje: {count}",
  "patterns.resultsCount": "{count} {count, plural, one {wykrój} other {wykroje}} znaleziono",
  "patterns.results.short": "{count} wyników",
  "patterns.noResults.title": "Brak znalezionych wykrojów",
  "patterns.noResults.message": "Spróbuj zmienić filtry lub słowa wyszukiwania.",
  "patterns.error.title": "Przepraszamy, nie możemy teraz wyświetlić wykrojów",
  "patterns.search.placeholder": "Szukaj wykrojów",
  "favourites.sort.label": "Sortowanie",
  "favourites.page.title": "Ulubione wykroje",
  "favourites.sort.recent": "Najnowsze ulubione",
  "favourites.sort.difficultyAsc": "Trudność: łatwy -> trudny",
  "favourites.sort.difficultyDesc": "Trudność: trudny -> łatwy",
  "favourites.search.placeholder": "Szukaj ulubionych wykrojów",
  "favourites.fetchError": "Nie udało się pobrać ulubionych wykrojów.",
  "favourites.empty.title": "Brak ulubionych wykrojów",
  "favourites.empty.message": "Dodaj wykroje do ulubionych, aby pojawiły się tutaj.",
  "favourites.filtered.empty.title": "Brak wyników dla wybranych filtrów",
  "favourites.filtered.empty.message": "Zmień filtry, aby zobaczyć więcej ulubionych wykrojów.",
  "nav.filters": "Filtry",
  "nav.invitationh1": "Pomożemy znaleźć wykrój, który chodzi Ci po głowie.",
  "nav.invitationp1":
    "Wykroje krawieckie od indywidualnych designerów/projektantów już od 5 EUR.",
  "nav.invitationinput": "Co chcesz uszyć?",
  "nav.invitationpbutton": "Zobacz wszystkie wykroje",
  "nav.patterndescription": "Opis produktu",
  "nav.sizetables": "Tabele rozmiarów",
  "nav.additionalinformation": "Dodatkowe informacje",
  "nav.patterns": "Wykroje",
  "nav.reviews": "Recenzji",
  "nav.headingTitleDHP":
    "Sprzedawaj swoje autorskie wykroje krawieckie i miej czas na tworzenie nowych",
  "nav.bodytitleDHP":
    "Jesteś pasjonatką szycia, rozpoznawalną projektantką - sama ustal cene za wykroje, zarabiaj ile chcesz.",
  "nav.startSellingPatterns": "Zacznij sprzedawać wykroje",
  "nav.headingInvitationDHP": "Zobacz co zyskujesz z Sewlight",
  "nav.bodyInvitationDHP":
    "Poznaj wszystkie korzyści płynące ze współpracy z nami",
  "nav.headingHowIsDHP": "Jak to działa?",
  "nav.bodyHowIsDHP": "zacznij przygode w 5 prostych krokach",
  "nav.headingHelpDHP": "Jesteśmy tutaj aby pomóc",
  "nav.bodyHelpDHP":
    "Jeśli masz jakieś pytania lub potrzebujesz pomocy, skontaktuj się z nami ;D",
  "nav.headingStartSell": "Zacznij sprzedawać swoje wykroje!",
  "nav.bodyStartSell":
    "Zarejestruj się i zacznij zarabiać na swoich wykrojach tyleile chcesz. Ustal cenę, my zajmiemy się resztą :D",

  "nav.support": "Pomoc",
  "nav.signup": "Zarejestruj Się",
  "nav.favorites": "Ulubione",
  "nav.cart": "Koszyk",
  "nav.purchaseHistory": "Historia zakupów",
  "nav.search": "Szukaj",
  "nav.contact": "Kontakt",
  "nav.sellYourPatterns": "Sprzedawaj swoje wykroje",
  "nav.alreadyHaveAccount": "Masz już konto?",
  "footer.brand.subtitle": "Marketplace cyfrowych wykrojow krawieckich",
  "footer.links.title": "Linki",
  "footer.links.privacyPolicy": "Polityka prywatnosci",
  "footer.links.platformTerms": "Regulamin platformy",
  "footer.links.creatorTerms": "Regulamin wspolpracy tworcow",
  "footer.links.newsletterTerms": "Regulamin newslettera",
  "footer.support.title": "Support",
};

const site = {
  "site.goBack": "Powrót",
  "site.logout": "Wyloguj",
  "site.login": "Zaloguj",
  "site.users": "użytkownicy",
  "site.orders": "zamówienia",
  "site.products": "produkty",
  "site.buyNow": "Kup teraz",
  "site.noAccount": "Nie masz jeszcze konta",
  "site.forgottenPassword": "Nie pamiętam hasła",
  "site.imageUpload.removeImage": "Usuń zdjęcie",
  "site.imageUpload.chooseImage": "Wybierz zdjęcie",
  "site.imageUpload.fileSizeTooBig": "Zbyt duży rozmiar pliku",
  "site.imageUpload.uploadLabel":
    "Maksymalny rozmiar pliku: 8 MB, akceptowane:  jpg | gif | png | jpeg | webp",
  "site.manageProfile.createProfile": "Stwórz Profil",
  "site.manageProfile.editProfile": "Edytuj Profil",
  "site.spinner.loading": "Ładowanie",
  "site.specification.lastUpdate": "Ostatnia aktualizacja",
  "site.patternDescription.tab1": "Opis produktu",
  "site.patternDescription.tab2": "Dodatkowe informacje",
  "site.previous": "Poprzedni",
  "site.next": "Następny",
  "site.yes": "Tak",
  "site.no": "Nie",
  "site.hello": "Witaj",
  "site.addToFavourites": "Dodaj do ulubionych",
  "site.manageUser": "Edytuj użytkownika",
  "site.reviews.noReviews": "Brak ocen",
  "site.commentForm.placeholder": "Skomentuj",
  "site.comments.leaveComment": "Zostaw komentarz",
  "site.comments.notLoggedInComments": "Zaloguj się aby móc ocenić wykrój",
  "site.reviews.reviewSubmitted": "Twoja ocena produktu została wysłana",
};

const contact = {
  "contact.title": "Skontaktuj się z nami",
  "contact.subtitle": "Chętnie Ci pomożemy. Napisz wiadomość, a odpowiemy tak szybko jak to możliwe.",
  "contact.form.title": "Wyślij nam wiadomość",
  "contact.form.success.title": "Wiadomość wysłana!",
  "contact.form.success.message": "Dziękujemy za kontakt. Wkrótce się z Tobą skontaktujemy.",
  "contact.form.name": "Twoje imię",
  "contact.form.name.placeholder": "Jan Kowalski",
  "contact.form.email": "Adres e-mail",
  "contact.form.email.placeholder": "jan@przyklad.pl",
  "contact.form.subject": "Temat",
  "contact.form.subject.placeholder": "W czym możemy pomóc?",
  "contact.form.message": "Wiadomość",
  "contact.form.message.placeholder": "Opisz szczegóły swojego zapytania...",
  "contact.form.submit": "Wyślij wiadomość",
  "contact.info.title": "Informacje kontaktowe",
  "contact.info.email.label": "E-mail",
  "contact.info.phone.label": "Telefon",
  "contact.info.hours.label": "Godziny pracy",
  "contact.info.hours.value": "Pon - Pt: 9:00 - 18:00",
  "contact.info.location.label": "Lokalizacja",
  "contact.info.location.value": "Warszawa, Polska",
  "contact.social.title": "Obserwuj nas",
};

const page404 = {
  "page404.message": "Guzik. Nic nie znaleźliśmy. Wróć do poprzedniej strony lub przejdź do strony głównej.",
  "page404.backButton": "Wróć do poprzedniej strony",
  "page404.homeButton": "Wróć do strony głównej",
};

const dashboard = {
  "dashboard.title": "Moje wykroje",
  "dashboard.noProfile.title": "Witaj! Zacznijmy",
  "dashboard.noProfile.message": "Nie utworzyłeś jeszcze profilu projektanta. Stwórz profil, aby zacząć sprzedawać swoje wykroje i nawiązać kontakt z klientami na całym świecie!",
  "dashboard.noProfile.button": "Stwórz profil",
  "dashboard.patterns.error.title": "Nie udało się pobrać Twoich wykrojów",
  "dashboard.patterns.empty.title": "Nie masz jeszcze wykrojów",
  "dashboard.patterns.empty.message": "Dodaj pierwszy wykrój, aby pojawił się tutaj.",
  "dashboard.patterns.filtered.empty.title": "Brak wyników dla wybranych filtrów",
  "dashboard.patterns.filtered.empty.message": "Zmień filtry, aby zobaczyć swoje wykroje.",
  "dashboard.patterns.search.placeholder": "Szukaj moich wykrojów",
  "dashboard.profileActions.editProfile": "Edytuj profil",
  "dashboard.profileActions.addPattern": "Dodaj wykrój",
  "dashboard.profileActions.designStudio": "Projektuj w Studio",
};

const cart = {
  "cart.goToyourCart": "Przejdź do swojego koszyka",
  "cart.addToCart": "Dodaj do koszyka",
  "cart.addedToCart.single": "Dodano do koszyka: {size}",
  "cart.addedToCart.multiple": "Dodano do koszyka rozmiary: {sizes}",
  "payment.method.title": "Metoda płatności",
  "payment.method.paypalLabel": "PayPal lub karta kredytowa",
  "payment.method.stripeLabel": "Stripe",
  "payment.continue": "Kontynuuj",
  "placeOrder.title": "Złóż zamówienie",
  "placeOrder.paymentMethod.title": "Metoda płatności",
  "placeOrder.paymentMethod.value": "Metoda: {method}",
  "placeOrder.cartEmpty": "Twój koszyk jest pusty",
  "placeOrder.order.title": "Zamówienie",
  "placeOrder.by": "Od",
  "order.card.items": "Liczba pozycji: {count}",
  "order.card.totalPriceLabel": "Łączna cena: {price}",
  "patterns.header.backToProfiles": "Powrót do profili",
  "cart.allSizesAlreadyInCart": "Wszystkie rozmiary tego wykroju są już w koszyku",
  "cart.selectAtLeastOneSize": "Wybierz co najmniej jeden rozmiar wykroju",
  "cart.alreadyInCart": "Produkt jest już w koszyku",
  "cart.copyLinkSuccess": "Skopiowano link do produktu",
  "cart.copyLinkFailed": "Nie udało się skopiować linku. Skopiuj adres z paska przeglądarki.",
  "cart.addedToFavourites": "Dodano do ulubionych",
  "cart.removedFromFavourites": "Usunięto z ulubionych",
  "cart.title": "Twój koszyk",
  "cart.pay": "Zapłać",
  "cart.patterns": "wykroje",
  "cart.totalPrice": "Łącznie",
  "cart.tableTitle.name": "nazwa",
  "cart.tableTitle.size": "rozmiar",
  "cart.tableTitle.price": "cena",
  "cart.tableTitle.totalPrice": "suma",
  "cart.tableTitlefavourites.removeFromList": "Usuń z ulubionych",
  "cart.tableTitlecart.removeFromList": "Usuń wykrój z koszyka",
  "cart.total": "Łącznie",
  "cart.summary": "Podsumowanie",
  "cart.favourites": "Ulubione",
  "cart.apply": "Zastosuj",
  "cart.promoCode.heading": "Masz kod promocyjny?",
  "cart.promoCode.placeholder": "Wprowadź kod",
  "cart.toast.applyingPromo": "Stosowanie promocji...",
  "cart.promoCode.applied": "✓ {code} zastosowany",
  "cart.promoCode.discountPercentage": "{value}% zniżki",
  "cart.promoCode.discountAmount": "{value} zniżki",
  "cart.promoCode.appliesTo": "Dotyczy {count, plural, one {# produktu} few {# produktów} many {# produktów} other {# produktów}}",
  "cart.promoCode.fromCreator": "od {creator}",
  "cart.discount": "Zniżka ({code})",
  "cart.subtotal": "Suma częściowa ({count, plural, one {# produkt} few {# produkty} many {# produktów} other {# produktów}})",
  "cart.remove": "Usuń",
  "cart.unknownSeller": "Nieznany",
  "cart.omnibusInfo": "Najniższa cena z 30 dni przed obniżką: {price}",
  "cart.sizePicker.title": "Wybierz rozmiar",
  "cart.sizePicker.description": "Wybierz rozmiar wykroju, ktory chcesz dodac do koszyka.",
  "cart.sizePicker.confirm": "Dodaj do koszyka",
  "cart.sizePicker.cancel": "Anuluj",
  "cart.changeSize": "Zmien rozmiar",
};

const client = {
  "categories.clients.title": "Dla kogo",
  "categories.clients.female": "Kobieta",
  "categories.clients.male": "Mężczyzna",
  "categories.clients.girl": "Dziewczynka",
  "categories.clients.boy": "Chłopiec",
  "categories.clients.infant": "Niemowle",
  "categories.clients.unisex": "Unisex",
  "cart.tableTitle.removeFromCart": "Usuń wykrój z koszyka",
};

const pattern = {
  "pattern.editPattern": "Edytuj wykrój",
  "pattern.addPattern": "Dodaj nowy wykrój",
  "pattern.draftDesign": "Wersja robocza",
  "product.editPattern": "Edytuj wykrój",
  "product.addPattern": "Dodaj wykrój",
  "pattern.difficulty.label": "Poziom trudności",
  "pattern.difficulty.easy": "Łatwy",
  "pattern.difficulty.medium": "Średni",
  "pattern.difficulty.hard": "Trudny",
  "pattern.yourpatterns.title": "Twoje wykroje",
  "pattern.removePattern": "Usuń wykrój",
  "pattern.removePattern.areYouSure": "Czy na pewno chcesz usunąć ten wykrój?",
  "cart.tableTitle.pattern": "wykrój",
  "cart.tableTitle.name": "nazwa",
  "cart.tableTitle.size": "rozmiar",
  "cart.tableTitle.price": "cena",
};

const sizes = {
  "categories.sizes.title": "Rozmiar",
  "categories.sizes.xxs": "XXS",
  "categories.sizes.xs": "XS",
  "categories.sizes.s": "S",
  "categories.sizes.m": "M",
  "categories.sizes.l": "L",
  "categories.sizes.xl": "XL",
  "categories.sizes.xxl": "XXL",
  "categories.sizes.xxxl": "XXXL",
  "categories.sizes.onesize": "One size",
};

const categories = {
  "categories.categories.title": "Kategoria",
  "categories.categories.dresses": "Sukienki",
  "categories.categories.skirts": "Spódnice",
  "categories.categories.trousers": "Spodnie",
  "categories.categories.blouses": "Bluzki",
  "categories.categories.shirts": "Koszule",
  "categories.categories.tshirts": "T-shirty",
  "categories.categories.sweaters": "Swetry",
  "categories.categories.cardigans": "Kardigany",
  "categories.categories.jackets": "Kurtki i kamizelki",
  "categories.categories.shorts": "Szorty",
  "categories.categories.newArrivals": "Nowości",
  "categories.categories.all": "Wszystkie kategorie",
  "category.page.titleAll": "Wszystkie kategorie",
  "category.page.sliderCategoryAll": "wszystkie kategorie",
  "nav.thumpnailsDesignerTitle": "Najlepiej oceniani projektanci w kategorii {category}",
};

const fabrics = {
  "categories.fabrics.title": "Polecany materiał",
  "categories.fabrics.cotton": "Bawełna",
  "categories.fabrics.flannel": "Flanela",
  "categories.fabrics.linen": "Bielizna",
  "categories.fabrics.fleece": "Runo",
  "categories.fabrics.canvas": "Brezentowy",
  "categories.fabrics.muslin": "Muślin",
  "categories.fabrics.precuts": "Precuts",
  "categories.fabrics.stretch": "Rozciągać",
  "categories.fabrics.rayon": "Sztuczny jedwab",
  "categories.fabrics.silk": "Jedwab",
  "categories.fabrics.wool": "Wełna",
  "categories.fabrics.other": "Inny",
};

const order = {
  "order.card.title": "Podsumowanie zamówienia",
  "order.card.finalize": "Złóż zamówienie",
  "order.summary.isPaid": "Zamówienie zrealizowane",
  "order.summary.isNotPaid": "Zamówienie nie opłacone",
  "order.summary.title": "Zamówienie {orderId}",
  "order.summary.orderHeading": "Zamówienie",
  "order.summary.payWithStripe": "Zapłać przez Stripe",
  "order.summary.stripeError": "Błąd Stripe",
  "order.summary.paymentUnknown": "Nieznany błąd płatności",
  "order.summary.paymentMethod": "Metoda płatności",
  "order.list.titleId": "Numer identyfikacyjny",
  "order.list.date": "Data",
  "order.list.total": "Cena",
  "order.list.paymentStatus": "Status płatności",
  "order.list.paid": "Zrealizowane",
  "order.list.unpaid": "Nie opłacone",
  "order.list.buttonDetails": "Szczegóły",
  "order.history.title": "Historia zakupów",
  "order.history.period.label": "Zakres",
  "order.history.period.last30": "Ostatnie 30 dni",
  "order.history.period.last90": "Ostatnie 90 dni",
  "order.history.period.last180": "Ostatnie 180 dni",
  "order.history.period.last365": "Ostatnie 365 dni",
  "order.history.period.all": "Wszystkie",
  "order.history.empty": "Brak zamówień w wybranym okresie.",
  "order.history.columns.orderNumber": "Numer zamówienia",
  "order.history.columns.product": "Produkt",
  "order.history.columns.name": "Nazwa",
  "order.history.columns.size": "Rozmiar",
  "order.history.columns.date": "Data",
  "order.history.columns.price": "Cena",
  "order.history.columns.paymentType": "Typ płatności",
  "order.history.columns.status": "Status",
  "order.history.year.label": "Rok",
  "order.history.range.label": "Zakres dat",
  "order.history.range.startAria": "Początek zakresu dat",
  "order.history.range.endAria": "Koniec zakresu dat",
  "order.history.statusFilter.label": "Filtruj po statusie",
  "order.history.statusFilter.all": "Wszystkie",
  "order.history.statusFilter.paid": "Zrealizowane",
  "order.history.statusFilter.cancelled": "Anulowane",
  "order.history.applyFilters": "Zastosuj",
  "order.history.action.cancel": "Anuluj",
  "order.history.dateRange.select": "Wybierz zakres dat",
  "order.history.loadMore.default": "Pokaż więcej",
  "order.history.loadMore.loading": "Ładowanie...",
  "order.history.showId": "Pokaż pełne ID",
  "order.history.hideId": "Ukryj ID",
  "order.history.copyId": "Kopiuj ID",
  "order.history.copied": "Skopiowano",
  "order.history.status.paid": "Zrealizowane",
  "order.history.status.cancelled": "Anulowane",
  "order.history.downloadPattern.title": "Pobierz wykrój",
  "order.history.downloadPattern.close": "Zamknij",
  "order.history.downloadPattern.availableFiles": "Dostępne pliki ({count})",
  "order.history.downloadPattern.pdfDocument": "Dokument PDF",
  "order.history.downloadPattern.download": "Pobierz",
  "order.history.downloadPattern.loadingPdf": "Ładowanie PDF...",
  "order.history.downloadPattern.failedToLoadPdf": "Nie udało się załadować pliku PDF.",
  "order.history.downloadPattern.selectFilePreview": "Wybierz plik, aby podglądać",
  "order.history.downloadPattern.downloadAll": "Pobierz wszystkie",
  "order.history.reason.paymentFailedFallback":
    "Transakcja została odrzucona lub anulowana.",
  "order.history.reason.paymentUnknownFallback":
    "Brak potwierdzenia statusu płatności.",
  "order.history.paymentType.cardStripe": "Karta (Stripe)",
};

const patternStudio = {
  "patternStudio.menu.button": "Menu",
  "patternStudio.menu.saveProject": "Zapisz projekt",
  "patternStudio.menu.exportToPDF": "Eksportuj do PDF",
  "patternStudio.menu.showGrid": "Pokaż siatkę",
  "patternStudio.menu.hideGrid": "Ukryj siatkę",
  "patternStudio.menu.moreComingSoon": "Więcej (wkrótce)",
  "patternStudio.toolbar.undo": "Cofnij (Ctrl+Z)",
  "patternStudio.toolbar.redo": "Ponów (Ctrl+Y)",
  "patternStudio.toolbar.undoLabel": "Cofnij",
  "patternStudio.toolbar.redoLabel": "Ponów",
  "patternStudio.unit.px": "Piksele",
  "patternStudio.unit.cm": "cm",
  "patternStudio.unit.in": "Cale",
  "patternStudio.canvas.label": "Płótno",
  "patternStudio.canvas.width": "Szerokość",
  "patternStudio.canvas.height": "Wysokość",
  "patternStudio.snapGrid": "Przyciąganie do siatki",
  "patternStudio.tool.select": "Zaznacz",
  "patternStudio.tool.hand": "Ręka",
  "patternStudio.tool.pen": "Pióro",
  "patternStudio.tool.bezierCurve": "Krzywa Beziera",
  "patternStudio.tool.bezierPenTitle": "Pióro Beziera — kliknij, aby umieścić kotwice (Enter kończy, Esc anuluje)",
  "patternStudio.tool.rectangle": "Prostokąt",
  "patternStudio.tool.circle": "Koło",
  "patternStudio.tool.line": "Linia",
  "patternStudio.tool.text": "Tekst",
  "patternStudio.properties.title": "Właściwości",
  "patternStudio.properties.type": "Typ",
  "patternStudio.properties.x": "X",
  "patternStudio.properties.y": "Y",
  "patternStudio.properties.width": "Szerokość",
  "patternStudio.properties.height": "Wysokość",
  "patternStudio.properties.radius": "Promień",
  "patternStudio.properties.length": "Długość",
  "patternStudio.properties.smoothing": "Wygładzanie",
  "patternStudio.properties.strokeColor": "Kolor obrysu",
  "patternStudio.properties.strokeWidth": "Szerokość obrysu",
  "patternStudio.properties.delete": "Usuń",
  "patternStudio.bezier.type": "Typ: Ścieżka pióra Beziera",
  "patternStudio.bezier.anchors": "Kotwice: {count}",
  "patternStudio.bezier.closePath": "Zamknij ścieżkę",
  "patternStudio.emptyState.zoomLabel": "Zoom",
  "patternStudio.emptyState.gridLabel": "Siatka",
  "patternStudio.layers.title": "Warstwy",
  "patternStudio.layers.selected": "zaznaczony",
  "patternStudio.layers.bezierLabel": "Beziera #{index}",
};

const admin = {
  "admin.userList.title": "Użytkownicy",
  "admin.patternList.createPattern": "Stwórz wykrój",
  "admin.patternList.title": "Wykroje",
  "admin.orderList.title": "Zamówienie",
  "admin.list.titleId": "ID",
  "admin.list.name": "Nazwa",
  "admin.list.user": "Użytkownik",
  "admin.patternList.empty": "Nie znaleziono wykrojów.",
  "admin.list.email": "Email",
  "admin.list.isAdmin": "Jest administratorem",
  "admin.list.notAdmin": "Nie jest administatorem",
  "admin.list.actions": "Akcje",
  "admin.adminList.confirmTitle": "Czy na pewno chcesz usunąć ten wykrój?",
  "admin.adminList.confirmUserDelete":
    "Czy na pewno chcesz usunąć tego użytkownika?",
  "admin.login.title": "Logowanie administratora",
  "admin.login.subtitle": "Dostęp tylko dla administratorów",
  "admin.login.emailLabel": "Email",
  "admin.login.emailPlaceholder": "admin@example.com",
  "admin.login.passwordLabel": "Hasło",
  "admin.login.passwordPlaceholder": "••••••••",
  "admin.login.button": "Zaloguj się",
  "admin.login.loading": "Logowanie...",
  "admin.sidebar.stats": "Statystyki",
  "admin.sidebar.users": "Użytkownicy",
  "admin.sidebar.orders": "Zamówienia",
  "admin.sidebar.patterns": "Wzory",
  "admin.sidebar.settings": "Ustawienia",
  "admin.sidebar.backToHome": "Powrót do strony głównej",
  "admin.sidebar.logout": "Wyloguj się",
  "admin.settings.title": "Ustawienia",
  "admin.settings.sectionCommission": "Prowizja",
  "admin.settings.labelCommissionRate": "Stawka prowizji (%)",
  "admin.settings.placeholderCommissionRate": "np. 1",
  "admin.settings.saved": "Zapisano",
  "admin.settings.buttonUpdateCommission": "Zaktualizuj prowizję",
  "admin.stats.sectionOrders": "Zamówienia",
  "admin.stats.sectionPatterns": "Wzory",
  "admin.stats.sectionUsers": "Użytkownicy",
  "admin.stats.orders.total": "Suma",
  "admin.stats.orders.creator": "Twórca",
  "admin.stats.orders.site": "Strona",
  "admin.stats.orders.totalRevenue": "Przychód całkowity",
  "admin.stats.orders.creatorRevenue": "Przychód twórcy",
  "admin.stats.orders.siteRevenue": "Przychód strony",
  "admin.stats.orders.commissionRate": "Stawka prowizji",
  "admin.stats.orders.platformCut": "Marża platformy",
  "admin.stats.orders.revenueBreakdown": "Rozkład przychodów",
  "admin.stats.orders.revenueSplit": "Podział przychodów",
  "admin.stats.orders.topOrders": "Najlepsze zamówienia",
  "admin.stats.orders.user": "Użytkownik",
  "admin.stats.orders.amount": "Kwota",
  "admin.stats.orders.date": "Data",
  "admin.stats.patterns.avgPrice": "Średnia cena",
  "admin.stats.patterns.totalPatterns": "Wszystkie wzory",
  "admin.stats.patterns.averagePrice": "Średnia cena",
  "admin.stats.patterns.topPatternSales": "Najwyższa sprzedaż wzoru",
  "admin.stats.patterns.atGlance": "Wzory w skrócie",
  "admin.stats.patterns.top5BySales": "Top 5 wzorów według sprzedaży",
  "admin.stats.patterns.topPatterns": "Najlepsze wzory",
  "admin.stats.patterns.patternName": "Nazwa wzoru",
  "admin.stats.patterns.totalSales": "Całkowita sprzedaż",
  "admin.stats.patterns.orders": "Zamówienia",
  "admin.stats.patterns.avgSale": "Średnia sprzedaż",
  "admin.stats.users.totalUsers": "Wszyscy użytkownicy",
  "admin.stats.users.creators": "Twórcy",
  "admin.stats.users.customers": "Klienci",
  "admin.stats.users.banned": "Zablokowani",
  "admin.stats.users.breakdown": "Rozkład użytkowników",
  "admin.stats.users.typeCounts": "Liczba typów użytkowników",
  "admin.stats.users.topCustomers": "Najlepsi klienci",
  "admin.stats.users.name": "Nazwa",
  "admin.stats.users.totalSpent": "Łącznie wydane",
  "admin.stats.users.avgOrder": "Średnia zamówienie",
  "creator.sidebar.dashboard": "Panel",
  "creator.sidebar.orders": "Zamówienia",
  "creator.sidebar.finance": "Finanse",
  "creator.sidebar.analytics": "Analizy",
  "creator.sidebar.promotions": "Promocje",
  "creator.sidebar.messages": "Wiadomości",
  "creator.sidebar.settings": "Ustawienia",
  "creator.sidebar.backToProfile": "Powrót do profilu",
  "creator.sidebar.backToHome": "Powrót do strony głównej",
  "creator.sidebar.logout": "Wyloguj się",
};

const comments = {};
const login = {};
const patternGrid = {};
const header = {};
const sidebar = {};
const hero = {
  "hero.learnMore": "Dowiedz się więcej",
};

const translations = {
  ...nav,
  ...contact,
  ...page404,
  ...dashboard,
  ...comments,
  ...login,
  ...patternGrid,
  ...header,
  ...sidebar,
  ...hero,
  ...site,
  ...pattern,
  ...categories,
  ...cart,
  ...client,
  ...fabrics,
  ...sizes,
  ...order,
  ...patternStudio,
  ...admin,
};

export default translations;
